/**
 * NSL context ids, one per demo surface.
 *
 * Each surface deliberately demonstrates a different console capability, so a
 * visitor can see the same catalogue reordered by different mechanisms:
 *
 *   general          - baseline ranking, diversity by topic
 *   homepageForYou   - pure personalised ranking
 *   editorsFrontPage - pin + boost: editorial control over a ranked page
 *   familyEdition    - filter: hard, auditable duty-of-care suppression
 *   tunedToYou       - bury on learned affinity + weighted_topic: behavioural
 *                      suppression with no editor-maintained list
 *   secondOpinion    - weighted_topic in invert mode: a filter-bubble
 *                      counterweight that argues with the other rails
 *   categories       - grouped section fronts
 *   youMayAlsoLike   - related items on an article
 *   comments         - ranked comment thread
 *
 * These are numeric because /v1/recommendations accepts only a numeric
 * context_id - context_key is rejected - so a recreated context always
 * requires a change here.
 */
export const RECOMMENDATION_CONTEXTS = Object.freeze({
  homepageForYou: "2323",
  general: "5",
  categories: "38",
  youMayAlsoLike: "2324",
  comments: "2325",
  editorsFrontPage: "2326",
  familyEdition: "2327",
  tunedToYou: "2328",
  secondOpinion: "2329",
});
